import { FilePreviewInline } from "@/components/file-preview";
import Spinner from "@/components/Spinner";

interface ContestAgreementsFilePreviewProps {
  fileUrl: string | null;
  fileName: string;
}

export const ContestAgreementsFilePreview = ({
  fileUrl,
  fileName,
}: ContestAgreementsFilePreviewProps) => (
  <div className="border-t border-slate-100 px-4 py-3">
    {fileUrl === null ? (
      <Spinner />
    ) : (
      <FilePreviewInline fileUrl={fileUrl} fileName={fileName} />
    )}
  </div>
);
